import React from 'react';
import Button from '@material-ui/core/Button';
import get from 'lodash/get';
import ArchivingProfile, {validate} from 'records/ArchivingProfile';
import InputField from 'components/pure/utils/form/InputField';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import ToggleField from 'components/pure/utils/form/ToggleField';
import FieldGroup from 'components/pure/utils/form/FieldGroup';
import './ArchivingProfileForm.styl';

export default class ArchivingProfileForm extends React.PureComponent {
  onChange(field, value) {
    const profile = this.props.profile || new ArchivingProfile({});
    this.props.onChange(profile.set(field, value));
  }

  render() {
    const {profile = {}} = this.props;
    const errors = validate(profile);
    return (
      <form className="archiving-profile-form ev-form">
        <FieldContainer
          label="Archiving Profile Name"
          errorOnBlur={true}
          error={get(errors, 'name[0]')}>
          <InputField
            value={profile.name || ''}
            placeholder="Archiving Profile Name"
            focused={true}
            onChange={value => this.onChange('name', value)}
            maxLength={25}
          />
        </FieldContainer>
        <FieldContainer
          className="days"
          label="Archive Calls After"
          errorOnBlur={true}
          error={get(errors, 'archiveAfterDays[0]')}>
          <div className="input-wrapper">
            <InputField
              value={profile.archiveAfterDays || ''}
              type="number"
              size={4}
              min={1}
              onChange={value => this.onChange('archiveAfterDays', value)}
            />
            <span>{profile.archiveAfterDays === 1 ? 'day' : 'days'}</span>
          </div>
        </FieldContainer>
        <FieldGroup title="Exceptions">
          <FieldContainer>
            <ToggleField
              onToggle={(_, val) => this.onChange('retainIfAnnotated', val)}
              toggled={profile.retainIfAnnotated}
              label="Do not archive calls with comments or highlights"
            />
          </FieldContainer>
          <FieldContainer>
            <ToggleField
              onToggle={(_, val) => this.onChange('retainIfSharedInternally', val)}
              toggled={profile.retainIfSharedInternally}
              label="Do not archive internally shared calls"
            />
          </FieldContainer>
          <FieldContainer>
            <ToggleField
              onToggle={(_, val) => this.onChange('retainIfSharedExternally', val)}
              toggled={profile.retainIfSharedExternally}
              label="Do not archive externally shared calls"
            />
          </FieldContainer>
          <FieldContainer>
            <ToggleField
              onToggle={(_, val) => this.onChange('retainIfSharedWithTeam', val)}
              toggled={profile.retainIfSharedWithTeam}
              label="Do not archive calls in shared libraries"
            />
          </FieldContainer>
        </FieldGroup>
        <div className="button-container">
          <Button
            variant="contained"
            color="primary"
            onClick={this.props.onSave}
            disabled={this.props.isSaving || !!errors}
            className="ev-button">
            Save
          </Button>
          <Button variant="outlined" onClick={this.props.onCancel} className="ev-button">
            Cancel
          </Button>
        </div>
      </form>
    );
  }
}
